<script setup lang="ts">
import { RouterLink, type NavigationFailure } from 'vue-router'
import SvgIcon from '../icon/SvgIcon.vue'

interface Props {
  to: string
  icon: string
  text: string
  expand?: boolean
  navigate?: (e?: MouseEvent | undefined) => Promise<void | NavigationFailure>
}

defineProps<Props>()
</script>

<template>
  <RouterLink v-bind="$props" custom v-slot="{ isActive, navigate }">
    <button
      type="button"
      class="relative flex items-center w-full px-3 py-2 transition-[width, opacity] linear duration-200 rounded-tl-lg rounded-br-lg cursor-pointer"
      :class="
        isActive ? 'inset-shadow-sm inset-shadow-black/50 bg-brand' : 'bg-black hover:bg-gray-800'
      "
      v-bind="$attrs"
      @click="navigate"
    >
      <SvgIcon :path="icon" class="w-6 h-6 fill-white shrink-0" />
      <div
        class="text-white whitespace-nowrap"
        :class="expand ? 'opacity-100' : 'opacity-0 w-0 overflow-hidden'"
      >
        <span class="ms-8">{{ text }}</span>
      </div>
    </button>
  </RouterLink>
</template>
